"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberToRgbValue = void 0;
var numeric_1 = require("../../../functions/numeric");
var round_to_int_1 = require("../../../functions/round-to-int");
var clamp255 = (0, numeric_1.clamp)(0, 255);
var numberToRgbValue = function (x) {
    return clamp255((0, round_to_int_1.roundToInt)(x));
};
exports.numberToRgbValue = numberToRgbValue;
